module.exports = __webpack_public_path__ + "static/Raleway-Bold-7802d8b27fcb19893ce6b38c0789268e.ttf";